import React from "react";
import { Link } from "react-router-dom";

import { trackerActions } from "../../modules/tracker";
import { DashboardEvents } from "../../modules/tracker/event-names";

import Button from "../Button";
import Toolbar, { ToolbarSegment } from "../Toolbar";
import DashboardStatusFilters from "./DashboardStatusFilters";

import * as styles from "../../styles/components/Dashboard.css";

const DashboardNav = ({ value, onStatusChange, teamId }) => (
    <div className={styles.dashboardNav}>
        <Toolbar gutters={0}>
            <ToolbarSegment>
                <div className={styles.statusFilters}>
                    <DashboardStatusFilters />
                </div>
            </ToolbarSegment>
            <ToolbarSegment>
                <div className={styles.createTestButton}>
                    <Link to={`/team/${teamId}/createTest`}>
                        <Button
                            theme="primary"
                            style={{ width: "180px", height: "40px" }}
                            onClick={() => {
                                trackerActions.trackEvent(
                                    DashboardEvents.DID_CLICK_CREATE_TEST,
                                    {
                                        teamId
                                    }
                                );
                            }}
                        >
                            {" "}
                            Create New Test{" "}
                        </Button>
                    </Link>
                </div>
            </ToolbarSegment>
        </Toolbar>
    </div>
);

export default DashboardNav;



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardNav.js